import React from "react";
import { Flex, Descriptions } from "antd";
import { getCurrentShopId } from "../shop/get-current-shop";
import dayjs from  'dayjs';

const keyMap = {
    payNo: '支付号',
    payTime: '支付时间',
    amount: '支付金额',
    payMethod: '支付方式',
    channelTrxNo: '支付渠道号',
}

export default () => {
    const [shopId, setShopId] = React.useState(null);
    const [payDetail, setPayDetail] = React.useState([]);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const payId = urlParams.get('payId');
        
        if (shopId && payId) {
            getPayDetail({payId, shopId}).then(res => {
                setPayDetail(res);
            })
        }
    }, [shopId]);

    const getPayDetail = async (params) => {
        const res = await fetch(`/api/pay/detail?shopId=${params.shopId}&payId=${params.payId}`);
        const result = await res.json();

        if(result && result.success) {
            // 处理数据
            const arr = [];
            Object.keys(result.data).forEach(key => {
                let value = result.data[key];
                if(value === null) {
                    value = '-';
                }
                // 金额处理
                if(key === 'amount') {
                    value = value / 100;
                }

                else if(key === 'payMethod') {
                    value = value === '1' ? '微信支付' : '-';
                }

                else if(key === 'payTime') {
                    value = dayjs(value).format('YYYY-MM-DD HH:mm:ss');
                }

                else if(key === 'benefits') {
                    value = value.filter(item => item.amount > 0);
                    value.forEach((item, index) => {
                        arr.push({
                            key: index,
                            label: item.remark+(item.shopId === shopId ? '(本店)' : ''),
                            children: item.amount / 100,
                        });
                    });
                }

                let label = keyMap[key];

                if(label) {
                    arr.push({
                        key,
                        label,
                        children: value,
                    });
                }
                
            });
            return arr;
        }

        return [];
    }

    return (
        <div>
            <h2 className="admin-page-title">支付详情</h2>
            <div className="admin-card p-4 md:p-6">
                <Descriptions bordered column={1} items={payDetail} />
            </div>
        </div>
    )
}